import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { UtilityService } from '@irb-common/services/utility.service';
import { DeleteAssetCategorydialogComponent } from './delete-asset-category-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class DeleteAssetCategoryDialogGridLayoutService implements GridLayoutService<DeleteAssetCategorydialogComponent> {
    constructor(private util: UtilityService) {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs(parent: DeleteAssetCategorydialogComponent) {
        return [{
            headerName: 'Category:',            
            field: 'valueLabel',
            maxWidth: 144,
            width: 144,
            comparator: this.util.sortString.bind(parent)
        },
        {
            headerName: 'Will no longer be:',
            field: 'entityType',
            minWidth: 90,
            comparator: this.util.sortString.bind(parent)
        },
        {
            headerName: 'For ths security/portfolio:',
            field: 'portfolioName',
            maxWidth: 144,
            width: 144,
            comparator: this.util.sortString.bind(parent)
        }];
    }
}